import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractControl, FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import { AuthenticationService } from '../services';

export abstract class BaseComponent {
  protected authService: AuthenticationService;
  protected router: Router;

  constructor(private injector: Injector) {
    this.authService = this.injector.get(AuthenticationService);
    this.router = this.injector.get(Router);
  }

  handleError(error: any, entityForm: FormGroup): boolean {
    let result = false;

    if (error instanceof HttpErrorResponse) {
      if (error.error && error.error.errors) {
        const formErrors = [];

        for (const fieldError of Object.keys(error.error.errors)) {
          const control = entityForm.get(
            fieldError.replace(/([\[])|(\]\.)/g, '.').replace(/\.[A-Z]/g, (str) => str.toLowerCase()),
          );

          const controlNames = fieldError
            .split(/\W/)
            .filter((v) => v !== '')
            .map((v) => this.normalizeName(v));

          let nestedControl: AbstractControl = null;
          let nestedIndex = 0;
          for (let index = controlNames.length; !nestedControl && index > 0; index--) {
            const controlPath = controlNames.slice(0, index).join('.');
            nestedControl = entityForm.get(controlPath);
            nestedIndex = index;
          }
          if (nestedControl) {
            let newControlPath = controlNames.slice(nestedIndex).join('.');

            if (newControlPath === '') {
              newControlPath = 'formError';
            }
            nestedControl.setErrors({
              [newControlPath]: error.error.errors[fieldError],
            });
            nestedControl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
          } else if (control) {
            control.setErrors({
              formError: error.error.errors[fieldError],
            });
            control.updateValueAndValidity({ emitEvent: false, onlySelf: true });
          } else {
            formErrors.push(error.error.errors[fieldError]);
          }
          result = true;
        }

        if (formErrors.length > 0) {
          entityForm.setErrors({
            formError: formErrors,
          });
          entityForm.updateValueAndValidity({ emitEvent: false, onlySelf: true });
        }
      } else if (error.error && error.error.title) {
        entityForm.setErrors({
          formError: [error.error.title],
        });
        entityForm.updateValueAndValidity({ emitEvent: false, onlySelf: true });
        result = true;
      }
    }
    return result;
  }

  normalizeName(str: string): string {
    return str.replace(/^\w/g, (match: string): string => {
      return match.toLowerCase();
    });
  }
}
